import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {ORDER_HEADERS} from './orderHeaders'

export const useGetOrderApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async (orderId: Params.GetOrder) => {
      const {data} = await ventrata.get<Ventrata.Order>(`/orders/${orderId}`, {
        headers: ORDER_HEADERS,
      })
      return data
    },
    [ventrata]
  )
}
